var pet_types = [];
var pet_statuses = [];
var del_statuses = [];
let petIcons = [];
let userLoggedIn = false;
let userData;
let loginCheck = $.Deferred();
let pagePrivate = false;

// Dog
petIcons[1] = {
	path: 'M 192,0 C 85.961106,0 0,85.961106 0,192 c 0,77.41292 26.969723,99.03113 172.26758,309.66992 9.53399,13.77299 29.92985,13.77399 39.46484,0 C 357.03028,291.03113 384,269.41292 384,192 384,85.961106 298.03889,0 192,0 Z m 17.72266,63.478516 c 2.1868,-0.257163 4.50971,0.400203 6.3457,2.234375 l 13.23633,13.238281 h 26.01953 a 15.527384,15.527384 0 0 1 13.88672,8.583984 l 3.47461,6.94336 h 31.05468 c 4.28944,0 7.76368,3.474233 7.76368,7.763674 v 15.52734 c 0,17.15288 -13.9018,31.05469 -31.05469,31.05469 h -15.52734 v 17.26367 L 202.8125,143.9082 V 71.201172 c 0,-4.32158 3.26548,-7.294053 6.91016,-7.722656 z m 39.67187,38.763674 c -4.28943,0 -7.76367,3.47423 -7.76367,7.76367 0,4.28945 3.47424,7.76367 7.76367,7.76367 4.28945,0 7.76367,-3.47422 7.76367,-7.76367 0,-4.28944 -3.47422,-7.76367 -7.76367,-7.76367 z M 78.591797,125.5332 c 8.574018,0 15.527344,6.95333 15.527344,15.52735 0,8.55946 6.967879,15.52734 15.527339,15.52734 h 82.51368 l 72.76172,25.98438 v 105.99804 c 0,4.28943 -3.47424,7.76367 -7.76368,7.76367 h -31.05468 c -4.28944,0 -7.76368,-3.47424 -7.76368,-7.76367 v -54.3457 h -77.63672 v 54.3457 c 0,4.28943 -3.47618,7.76367 -7.76562,7.76367 h -31.05469 c -4.289434,0 -7.763669,-3.47424 -7.763669,-7.76367 V 184.7793 C 76.083133,178.35 63.064453,161.27525 63.064453,141.06055 c 0,-8.57402 6.953325,-15.52735 15.527344,-15.52735 z',
	fillColor: "#0000ff",
	fillOpacity: 1,
	strokeWeight: 1,
	strokeColor: "#ffffff",
	scale: 0.075,
	anchor: {x: 192, y: 512},
}

// Cat
petIcons[2] = {
	path: 'M 192,0 C 85.961106,0 0,85.961106 0,192 c 0,77.41292 26.969723,99.03113 172.26758,309.66992 9.53399,13.77299 29.92985,13.77399 39.46484,0 C 357.03028,291.03113 384,269.41292 384,192 384,85.961106 298.03889,0 192,0 Z m 25.05078,68.595703 28.9043,28.902344 h 28.90234 l 28.90235,-28.902344 v 60.695317 c 0,23.94415 -19.40936,43.35546 -43.35352,43.35546 -23.94417,0 -43.35547,-19.41131 -43.35547,-43.35546 z M 86.988281,97.498047 c 23.908039,0 43.355469,19.447433 43.355469,43.355473 v 38.81445 c 25.18607,-37.92137 64.31237,-38.81445 73.42578,-38.81445 5.3696,26.35122 28.72294,46.24414 56.63672,46.24414 5.01734,0 9.80415,-0.845 14.45117,-2.05078 v 93.09374 c 0,3.99221 -3.23435,7.22657 -7.22656,7.22657 h -14.45117 c -3.9922,0 -7.22461,-3.23436 -7.22461,-7.22657 v -65.03124 l -57.80664,43.35546 h 14.45117 c 7.97988,0 14.45117,6.47129 14.45117,14.45118 v 7.2246 c 0,3.99221 -3.2324,7.22657 -7.22461,7.22657 h -79.48242 c -15.9417,0 -28.9043,-12.96065 -28.9043,-28.90235 V 140.85352 c 0,-7.96634 -6.484836,-14.45118 -14.451169,-14.45118 -7.979881,0 -14.451172,-6.47325 -14.451172,-14.45312 0,-7.97989 6.471291,-14.451173 14.451172,-14.451173 z M 242.3418,119.17578 c -3.9922,0 -7.22657,3.23436 -7.22657,7.22656 0,3.9922 3.23437,7.22461 7.22657,7.22461 3.99219,0 7.22461,-3.23241 7.22461,-7.22461 0,-3.9922 -3.23242,-7.22656 -7.22461,-7.22656 z m 36.1289,0 c -3.99219,0 -7.22656,3.23436 -7.22656,7.22656 0,3.9922 3.23437,7.22461 7.22656,7.22461 3.9922,0 7.22461,-3.23241 7.22461,-7.22461 0,-3.9922 -3.23241,-7.22656 -7.22461,-7.22656 z',
	fillColor: "#0000ff",
	fillOpacity: 1,
	strokeWeight: 1,
	strokeColor: "#ffffff",
	scale: 0.075,
	anchor: {x: 192, y: 512},
}

// Bird
petIcons[3] = {
	path: 'M 192,0 C 85.961106,0 0,85.961106 0,192 c 0,77.41292 26.969723,99.03113 172.26758,309.66992 9.53399,13.77299 29.92985,13.77399 39.46484,0 C 357.03028,291.03113 384,269.41292 384,192 384,85.961106 298.03889,0 192,0 Z m 59.69336,72.835938 c 11.28956,-10e-7 21.22141,5.487584 27.53906,13.847656 h 7.07813 c 22.94259,0 41.54101,12.396857 41.54101,27.693356 l -41.54101,6.92383 v 34.61719 c 0,37.7588 -25.20938,69.5801 -59.70117,79.67969 l 17.8457,48.26172 c 0.98227,2.69582 -0.4077,5.67202 -3.10352,6.65429 l -9.75781,3.55274 c -2.69582,0.98226 -5.67203,-0.40575 -6.6543,-3.10157 L 205.67773,238.875 c -0.82216,0.026 -1.62078,0.125 -2.44726,0.125 h -16.90235 l 16.58594,44.86328 c 0.98226,2.69583 -0.4077,5.67398 -3.10351,6.65625 l -9.75782,3.55274 c -2.69582,0.98226 -5.67203,-0.40769 -6.65429,-3.10352 L 164.18164,239 h -41.75391 l -52.591792,26.29688 c -8.693269,4.34446 -18.921876,-1.97847 -18.921876,-11.69727 a 13.074959,13.074959 0 0 1 5.230469,-10.45899 L 217.07617,116.5332 v -9.08008 c 0,-19.117393 15.4998,-34.617182 34.61719,-34.617182 z m 0,24.232421 c -5.73348,0 -10.38477,4.646951 -10.38477,10.384761 0,5.73349 4.65129,10.38672 10.38477,10.38672 5.73348,0 10.38476,-4.65323 10.38476,-10.38672 10e-6,-5.73781 -4.65128,-10.384761 -10.38476,-10.384761 z',
	fillColor: "#0000ff",
	fillOpacity: 1,
	strokeWeight: 1,
	strokeColor: "#ffffff",
	scale: 0.075,
	anchor: {x: 192, y: 512},
}

// Reptile
petIcons[4] = {
	path: 'M 192,0 C 85.961106,0 0,85.961106 0,192 c 0,77.41292 26.969723,99.03113 172.26758,309.66992 9.53399,13.77299 29.92985,13.77399 39.46484,0 C 357.03028,291.03113 384,269.41292 384,192 384,85.961106 298.03889,0 192,0 Z m -67.47266,69.449219 c 1.93993,-0.02022 3.90502,0.06413 5.88868,0.257812 27.66194,2.695484 47.92382,27.562607 47.92382,55.353519 v 104.11718 c 0,7.33771 5.97286,13.31055 13.31055,13.31055 7.3377,0 13.3125,-5.97284 13.3125,-13.31055 v -26.62304 c 0,-29.40486 23.83927,-53.24414 53.24414,-53.24414 h 1.89649 c 4.80028,-12.59556 18.65962,-20.30326 32.54882,-16.03125 l 36.01954,11.07812 c 5.58646,1.71795 9.40039,6.88024 9.40039,12.72461 v 25.21094 c 0,5.89428 -3.88018,11.08952 -9.53321,12.76172 l -36.15625,10.69922 c -13.96823,4.13474 -27.81243,-3.7728 -32.42969,-16.50977 h -1.74609 c -7.35017,0 -13.3125,5.96037 -13.3125,13.31055 v 26.62304 c 0,31.1145 -26.826,56.08114 -58.56445,52.98633 -27.66196,-2.69964 -47.92383,-27.56651 -47.92383,-55.35742 V 122.68945 c 0,-7.3377 -5.97284,-13.3125 -13.31055,-13.3125 -7.33769,0 -13.31054,5.9748 -13.31054,13.3125 v 79.66993 a 215.68608,215.68608 0 0 1 -13.736332,75.74414 c -2.158883,5.75701 -10.302056,5.75701 -12.460937,0 -9.084772,-24.22189 -13.736329,-49.87917 -13.736329,-75.74414 v -79.66993 c 10e-7,-29.169834 23.576922,-52.93686 52.675778,-53.240231 z m 166.95704,79.861331 c -3.67718,0 -6.65626,2.97908 -6.65626,6.65625 0,3.67716 2.97908,6.65429 6.65626,6.65429 3.67715,0 6.65429,-2.97713 6.65429,-6.65429 0,-3.67717 -2.97714,-6.65625 -6.65429,-6.65625 z m 0,26.62304 c -3.67718,0 -6.65626,2.97712 -6.65626,6.6543 0,3.67716 2.97908,6.65625 6.65626,6.65625 3.67715,0 6.65429,-2.97909 6.65429,-6.65625 0,-3.67718 -2.97714,-6.6543 -6.65429,-6.6543 z',
	fillColor: "#0000ff",
	fillOpacity: 1,
	strokeWeight: 1,
	strokeColor: "#ffffff",
	scale: 0.075,
	anchor: {x: 192, y: 512},
}

// Farm Animal
petIcons[5] = {
	path: 'M 192,0 C 85.961106,0 0,85.961106 0,192 c 0,77.41292 26.969723,99.03113 172.26758,309.66992 9.53399,13.77299 29.92985,13.77399 39.46484,0 C 357.03028,291.03113 384,269.41292 384,192 384,85.961106 298.03889,0 192,0 Z M 76.769531,84.439453 H 246.24023 a 51.020099,51.020099 0 0 1 41.31446,21.087887 l 34.97265,48.29883 c 3.63423,-5.00504 8.22964,-9.35211 13.97852,-12.22656 5.65325,-2.82663 12.30469,1.28612 12.30469,7.60351 V 190.125 l 5.31445,7.33789 c 2.73631,3.77769 3.77129,8.5333 2.85742,13.11328 l -11.54492,57.7168 c -2.34844,11.73156 -12.64599,20.17383 -24.61133,20.17383 a 25.095885,25.095885 0 0 1 -20.88086,-11.17188 l -21.95898,-32.9375 a 33.988604,33.988604 0 0 1 -5.71289,-18.86133 v -22.03906 l -17.00196,-17.00391 v 93.51368 c 0,4.69687 -3.80312,8.5 -8.5,8.5 h -34.00586 c -4.69686,0 -8.5,-3.80313 -8.5,-8.5 v -59.49219 c -4.93065,4.93065 -10.73917,8.73025 -16.96093,11.57812 v 13.91016 c 0,4.69688 -3.80314,8.5 -8.5,8.5 -4.69688,0 -8.50196,-3.80312 -8.50196,-8.5 v -9.20312 c -10.19604,1.25891 -12.16693,0.59898 -17.00195,0.004 v 9.19727 c 0,4.69687 -3.80312,8.50195 -8.5,8.50195 -4.69686,0 -8.50195,-3.80508 -8.50195,-8.50195 v -13.88282 c -6.24834,-2.85318 -12.07153,-6.66723 -17.02344,-11.61914 v 59.50782 c 0,4.69687 -3.80509,8.5 -8.50195,8.5 H 76.769531 c -4.696875,0 -8.501953,-3.80313 -8.501953,-8.5 V 118.44531 c 0,-2.375 0.250641,-4.68751 0.712891,-6.92969 -7.858232,3.12417 -13.462891,10.71827 -13.462891,19.68165 v 55.25585 c 0,18.78219 -15.223678,34.00586 -34.005859,34.00586 h -4.25 v -17.0039 c 0,-10.69017 5.037181,-20.11526 12.751953,-26.34766 v -45.91015 c 0,-25.82218 20.933685,-46.757817 46.755859,-46.757817 z m 40.921879,34.005857 c -13.04393,0 -20.174623,12.60758 -11.82227,20.91211 l 12.16211,12.08789 c 11.5881,11.52434 27.31048,18 43.70703,18 h 0.0898 c 16.39124,0 32.11362,-6.47035 43.70704,-18 l 12.16211,-12.08789 c 8.35236,-8.30453 1.2211,-20.91211 -11.82813,-20.91211 z m 205.61718,102.01367 c -4.69687,0 -8.50195,3.80313 -8.50195,8.5 0,4.69688 3.80508,8.50196 8.50195,8.50196 4.69156,0 8.5,-3.80508 8.5,-8.50196 0,-4.69687 -3.80312,-8.5 -8.5,-8.5 z',
	fillColor: "#0000ff",
	fillOpacity: 1,
	strokeWeight: 1,
	strokeColor: "#ffffff",
	scale: 0.075,
	anchor: {x: 192, y: 512},
}

// Other
petIcons[6] = {
	path: 'M 192,0 C 85.961106,0 0,85.961106 0,192 c 0,77.41292 26.969723,99.03113 172.26758,309.66992 9.53399,13.77299 29.92985,13.77399 39.46484,0 C 357.03028,291.03113 384,269.41292 384,192 384,85.961106 298.03889,0 192,0 Z m -50.18164,64.158203 c 13.86528,0.308649 27.89111,13.726701 33.10937,32.863281 5.96374,21.870366 -1.83369,42.925326 -17.41796,47.025396 -15.57924,4.10509 -33.05191,-10.30151 -39.01563,-32.17188 -5.96373,-21.870365 1.83368,-42.923372 17.41797,-47.023438 1.94803,-0.512508 3.92549,-0.737452 5.90625,-0.693359 z m 94.40625,0 c 1.98075,-0.04375 3.95822,0.180221 5.90625,0.693359 15.58427,4.105106 23.3817,25.153073 17.41797,47.023438 -5.96374,21.87037 -23.4333,36.27193 -39.01758,32.17188 -15.58427,-4.10007 -23.3817,-25.15503 -17.41797,-47.025396 5.21826,-19.13658 19.24605,-32.557043 33.11133,-32.863281 z M 84.337891,128.625 c 12.986713,0.0535 25.914429,10.61731 30.498049,25.88867 5.23841,17.45297 -2.40081,34.44156 -17.068362,37.94727 -14.667554,3.5057 -30.806509,-7.79702 -36.044922,-25.25 -5.238413,-17.45299 2.402758,-34.44156 17.070313,-37.94727 1.833444,-0.43821 3.689677,-0.64631 5.544922,-0.63867 z m 209.361329,0.006 c 1.85512,-0.008 3.71148,0.1985 5.54492,0.63672 14.66756,3.5057 22.30873,20.49623 17.07031,37.94922 -5.24344,17.45298 -21.37736,28.7557 -36.04492,25.25 -14.66755,-3.50571 -22.30873,-20.49624 -17.07031,-37.94922 4.58802,-15.27135 17.51418,-25.83321 30.5,-25.88672 z m -104.67774,32.23437 c 39.9983,0 96.70899,61.83403 96.70899,100.86524 0,17.5789 -13.50382,28.08008 -36.13477,28.08008 -24.3838,0 -40.67329,-12.63282 -60.57422,-12.63282 -19.72968,0 -35.97383,12.63282 -60.57421,12.63282 -22.63095,0 -36.13477,-10.50118 -36.13477,-28.08008 0,-39.03121 56.71068,-100.86524 96.70898,-100.86524 z',
	fillColor: "#0000ff",
	fillOpacity: 1,
	strokeWeight: 1,
	strokeColor: "#ffffff",
	scale: 0.075,
	anchor: {x: 192, y: 512},
}

var mapStyles =[

 {
        "featureType": "administrative",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "lightness": 33
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#f7f7f7"
            }
        ]
    },
    {
        "featureType": "poi.business",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#deecdb"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "lightness": "25"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "lightness": "25"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels",
        "stylers": [
            {
                "saturation": "-90"
            },
            {
                "lightness": "25"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#cccccc"
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#eeeeee"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit.station",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#e0f1f9"
            }
        ]
    },
	{
			featureType: "poi.business",
			elementType: "labels",
			stylers: [
						{ visibility: "off" }
			]
	},
	{
			featureType: "poi.attraction",
			elementType: "labels",
			stylers: [
						{ visibility: "off" }
			]
	},
	{
			featureType: "administrative.neighborhood",
			elementType: "labels",
			stylers: [
						{ visibility: "off" }
			]
	},
];


$(document).ready(function() {
	$('.d-none').hide().removeClass('d-none');
	checkLogin();
});



function checkLogin() {
	return $.ajax({
			type  : 'POST',
			url: '/utils/check_status.php',
			dataType  : 'json',
			xhrFields: { withCredentials: true },
			crossDomain: true,
			encode  : true
		})
		.done(function(data) {
			if ( ! data.success) {
				userData = null;
				userLoggedIn = false;
				$('.logout_btn').hide();
				$('.login_btn').show();

				$('.account_links').hide();

				loginCheck.resolve(false);
			} else {
				userData = data;
				userLoggedIn = true;
				$('.logout_btn').show();
				$('.login_btn').hide();
				$('.account_links').show();
				if (data.client_info.acct_type == 10) {
					$('.admin_link').show();
					$('.my_account_link').hide();
				} else {
					$('.my_account_link').show();
					$('.admin_link').hide();
				}
				loginCheck.resolve(true);
			}
		})
		.fail(function(XMLHttpRequest, textStatus, errorThrown) {
			console.log(XMLHttpRequest);
			console.log(textStatus);
			console.log(errorThrown);
			$('#user_err_msg').text(textStatus);
			$('#user_err').show();
			loginCheck.resolve(false);
		});
}


$(document).on('click', '.logout', function() {
	$.ajax({
		type  : 'POST',
		url   : '/utils/logout.php',
		dataType  : 'json',
		xhrFields: { withCredentials: true },
		encode  : true
	})
	.done(function(data) {
		if ( ! data.success) {
			console.log(data);
		} else {
				userData = null;
				userLoggedIn = false;
				$('.logout_btn').hide();
				$('.login_btn').show();
				$('.account_links').hide();
				if (pagePrivate) {
					window.location.replace('/login.html?return_url=' + window.location.pathname);
				}
		}
	})
	.fail(function(XMLHttpRequest, textStatus, errorThrown) {
		console.log(XMLHttpRequest);
		console.log(textStatus);
		console.log(errorThrown);
		$('#user_err_msg').text(textStatus);
		$('#user_err').show();
	});
});



function petTypesGet() {
	return $.ajax({
	type  : 'GET',
	url   : '/utils/get_pet_types.php',
	data  : {},
	dataType  : 'json',
	encode  : true
	})
	.done(function(data) {
	if ( ! data.success) {
		// Error - show it to the user
		var error_message = '';
		$.each(data.errors, function (i,v) {
		error_message = error_message + "<br>" + v;
		});
		$("#report-err-msg").html(error_message);
		$("#report-err").modal("show");
		$("#report-wait").hide();
	} else {
		$('#report-err').hide();
		$("#report-wait").hide();
		$('#pet_type_input').empty();
		$('#pet_type_input').append($('<option value="" selected>Please Select</option>'));
		$.each(data.pet_types, function(i,pt) {
			//console.log(p);
			pet_types[pt.pt_id] = pt;
			$('#pet_type_input').append($('<option value="' + pt.pt_id + '">' + pt.name + '</option>'));
		});
	}
	});
}

function petStatusesGet() {
	return $.ajax({
	type  : 'GET',
	url   : '/utils/get_pet_statuses.php',
	data  : {},
	dataType  : 'json',
	encode  : true
	})
	.done(function(data) {
	if ( ! data.success) {
		// Error - show it to the user
		var error_message = '';
		$.each(data.errors, function (i,v) {
		error_message = error_message + "<br>" + v;
		});
		$("#report-err-msg").html(error_message);
		$("#report-err").modal("show");
		$("#report-wait").hide();
	} else {
		$('#report-err').hide();
		$("#report-wait").hide();
		$('#pet_status_input').empty();
		$('#pet_status_input').append($('<option value="" selected>Please Select</option>'));
		$.each(data.pet_statuses, function(i,ps) {
			//console.log(p);
			pet_statuses[ps.ps_id] = ps;
		});
	}
	});
}

function petsGet() {
	return $.ajax({
		type  : 'GET',
		url   : '/utils/get_pets.php',
		data  : {},
		dataType  : 'json',
		encode  : true
	})
	.done(function(data) {
		if ( ! data.success) {
			// Error - show it to the user
			var error_message = '';
			$.each(data.errors, function (i,v) {
				error_message = error_message + "<br>" + v;
			});
		$("#report-err-msg").html(error_message);
		$("#report-err").modal("show");
		$("#report-wait").hide();
	} else {
		$('#report-err').hide();
		$("#report-wait").hide();
		$('#pet_type_input').empty();
		$('#pet_type_input').append($('<option value="" selected>Please Select</option>'));
		$.each(data.pets, function(i,p) {
			pets[p.pet_id] = p;
			if (pOrder) {
				pOrder.push(p.pet_id);
			}
		});
	}
	});
}

function delReasonsGet() {
	return $.ajax({
		type  : 'GET',
		url   : '/utils/get_del_statuses.php',
		data  : {},
		dataType  : 'json',
		encode  : true
	})
	.done(function(data) {
		if ( ! data.success) {
			// Error - show it to the user
			var error_message = '';
			$.each(data.errors, function (i,v) {
				error_message = error_message + "<br>" + v;
			});
		$("#report-err-msg").html(error_message);
		$("#report-err").modal("show");
		$("#report-wait").hide();
	} else {
		$('#report-err').hide();
		$("#report-wait").hide();
		$.each(data.del_statuses, function(i,p) {
			del_statuses.push(p);
		});
	}
	});
}